import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 親ID
 */
export class ParentId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): ParentId {
    return new ParentId(value);
  }
}
